import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * APM 트리 데이터를 조회한다.
   * @param  {[type]} treeType [description]
   * @return {[type]}          [description]
   * @author jda
   */
  getApmTreeByType(treeType) {
    return axios.get(`${baseUrl}/apm2x/tree/get-apm-tree-by-type.do`, { params: { treeType } });
  },
  /**
   * 어플리케이션 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getApplicationList(params) {
    return axios.post(`${baseUrl}/apm2x/common/get-application-list.do`, params);
  },
  /**
   * SQL 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSqlList(params) {
    return axios.post(`${baseUrl}/apm2x/common/get-sql-list.do`, params);
  },
  /**
   * API 호출 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getApiCallList(params) {
    return axios.post(`${baseUrl}/apm2x/common/get-api-call-list.do`, params);
  },
  /**
   * 트랜잭션 예외 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getServiceErrorList(params) {
    return axios.post(`${baseUrl}/apm2x/common/get-service-error-list.do`, params);
  },
  /**
   * 경보 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getAlertList(params) {
    return axios.post(`${baseUrl}/apm2x/common/get-alert-list.do`, params);
  },
  /**
   * 엔드유저 목록을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEndUserDataList(params) {
    return axios.post(`${baseUrl}/apm2x/common/get-end-user-data-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/apm/common.js